import Vue from "vue";

Vue.component("wto-multi-select-text", {
	props: ["label", "placeholder", "items", "noItemMessage", "renderedItems", "output", "isReadOnly"],
	data() {
		return {
			selectItems: [],
			options: this.items
		};
	},
	methods: {
		getFilteredItems(text) {
			this.options = this.items.filter((option) => {
				return option.toLowerCase().indexOf(text.toLowerCase()) >= 0;
			});
		},
		getDataSourceMultiText: (value) => {
			if (value) {
				var returnValue = "";
				const items = value.split(",");
				items.forEach(function (item) {
					returnValue += `${item}; `;
				});
				returnValue = !returnValue ? "" : returnValue.substr(0, returnValue.length - 2);
				return returnValue;
			}
			return "";
		},
	},
	watch: {
		selectItems: function () {
			this.$emit("update:output", this.selectItems.join());
		},
		renderedItems: function (val) {
			this.selectItems = val;
		}
	},
	template: `
		<b-field :label="label">
			<b-taginput v-if="!isReadOnly" v-model="selectItems" :data="options" autocomplete ref="taginput" icon="label" :allow-new="true" :placeholder="placeholder" @typing="getFilteredItems">
				<template slot-scope="props"> {{props.option}} </template>
				<template #empty> {{ noItemMessage }} </template>
				<template #selected="props">
                    <b-tag v-for="(item, index) in props.selectItems" :key="index" rounded :tabstop="false" ellipsis closable @close="$refs.taginput.removeTag(index, $event)">
                        {{item}}
                    </b-tag>
                </template>
			</b-taginput>
			<div v-if="isReadOnly" class="input">{{ getDataSourceMultiText(output) }}</div>
		</b-field>
	`
});